import React, { useMemo } from "react";
import { Spin } from "antd";
import { useAuth } from "../../context/AuthContext";
import { KYC_VERIFIED as T } from "../../config/zinihubConfig";
import styles from "./KYCVerified.module.css";

const KYCVerified = () => {
  const { token, decodeToken } = useAuth();
  const decodedToken = useMemo(() => decodeToken(token), [token, decodeToken]);

  if (!decodedToken) {
    return (
      <div className={styles.loadingWrap}>
        <Spin size="large" />
        <p className={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.pageTitle}>{T.PAGE_TITLE}</div>

      <div className={styles.statusCard}>
        <div className={styles.statusHeader}>
          <div className={styles.statusIconWrap}>
            <span>{T.STATUS_ICON}</span>
          </div>
          <div className={styles.statusInfo}>
            <div className={styles.statusTitle}>{T.STATUS_TITLE}</div>
            <div className={styles.statusDate}>{T.VERIFIED_ON}</div>
          </div>
          <span className={styles.statusBadge}>{T.BADGE}</span>
        </div>
        <div className={styles.chipRow}>
          {T.CHIPS.map((chip) => (
            <span key={chip} className={styles.chip}>{chip}</span>
          ))}
        </div>
        <div className={styles.reverifyText}>
          {T.REVERIFY_TEXT} <span className={styles.reverifyLink}>{T.REVERIFY_LINK}</span>
        </div>
      </div>

      <div className={styles.hintCard}>
        <div className={styles.hintTitle}>{T.HINT_TITLE}</div>
        <div className={styles.hintBody}>{T.HINT_BODY}</div>
      </div>

      <div className={styles.docsCard}>
        <div className={styles.docsTitle}>{T.DOCS_TITLE}</div>
        {T.DOCS.map(({ icon, title }) => (
          <div key={title} className={styles.docRow}>
            <span>{icon}</span>
            <div className={styles.docContent}>
              <div className={styles.docTitle}>{title}</div>
            </div>
            <span className={styles.docStatus}>{T.VERIFIED_LABEL}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KYCVerified;
